import { render, staticRenderFns } from "./NeedsAIChat.vue?vue&type=template&id=dd689fdc&scoped=true&"
import script from "./NeedsAIChat.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsAIChat.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./NeedsAIChat.vue?vue&type=style&index=0&id=dd689fdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd689fdc",
  null
  
)

export default component.exports